import _ from 'lodash'
import crypto from 'crypto-js'
// import { getLogger } from '~/utils/format';

export const adminHost = 'https://console.jufair.com/'
export const baiduKey = '2S3s4gNOF62azDbcLnGHf1Lunv6eoGkM'
export const baiduKey2 = '5KaZ4OvFfchHnfVcMSeDAlkKnzd2Dh04' // 服务端 key
export const gaodeKey = '8607adb51cc446875a7a4da2f229da22'
export const bucketHost = 'jufiarbackend.oss-cn-shanghai.aliyuncs.com'
export const bucketCdnHost = 'file.jufair.com'
export const MINI_HOST = 'https://test.jufair.com'
export const jufairOss = 'jufair.oss-cn-shanghai.aliyuncs.com'
export const dcdnurl = 'dcdn-jufair.jufair.com'
export const OSS_BUCKET_URL = 'https://dcdn-jufair.jufair.com' // 'https://jufair.oss-cn-shanghai.aliyuncs.com';
import { useError } from '#app'
import * as env from '~~/config/env'
const MODE: keyof typeof env = (process.env.MODE || 'dev') as keyof typeof env

export const sleep = (delay: number) => {
  return new Promise(resolve => {
    setTimeout(() => resolve(delay), delay)
  })
}

// 替换图片域名
export const handlerReplaceImageHost = (url: string) => {
  return url.replace('http://', 'https://').replace(bucketHost, bucketCdnHost)
}

// 检测设备 pc电脑端 h5移动端
export const checkDevice = (): any => {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return 'h5'
  } else {
    // console.log('PC');
    return 'pc'
  }
}

// 获取周几/星期几
export const getWeekStr = (str: number): string => {
  let obj: any = {
    0: '日',
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    6: '六'
  }
  return obj[str]
}

const supportsWebp = ({ createImageBitmap, Image }: any): Promise<boolean> => {
  if (!createImageBitmap || !Image) return Promise.resolve(false)

  return new Promise(resolve => {
    const image = new Image()
    image.onload = () => {
      createImageBitmap(image)
        .then(() => {
          resolve(true)
        })
        .catch(() => {
          resolve(false)
        })
    }
    image.onerror = () => {
      resolve(false)
    }
    image.src = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA='
  })
}

export const webpIsSupported = (): Promise<boolean> => {
  if (process.client) {
    return supportsWebp(window)
  } else {
    return Promise.resolve(true)
  }
}

export const checkFile = (file: File, minSize = [600, 800]) => {
  const isSize = new Promise<boolean>(function (resolve) {
    const [width, height] = minSize
    const _URL = window.URL || window.webkitURL
    const img = new Image()
    img.onload = function () {
      const valid = img.width >= width && img.height >= height
      //   console.log(img.width, img.height, minSize);
      resolve(valid)
    }
    img.src = _URL.createObjectURL(file)
  }).catch(() => {
    return Promise.reject(new Error('尺寸大小不合适'))
  })
  return isSize
}

interface Message {
  delay?: number
  type: 'success' | 'info' | 'warning' | 'error'
  title?: string
  msg?: string
}

export const message = function (config: Message) {
  const { delay = 3000, type, title = '', msg = '' } = config

  ElMessageBox.confirm(msg, title, {
    showCancelButton: false,
    showConfirmButton: false,
    roundButton: true,
    type,
    center: true
  })
    .then(() => {
      //
    })
    .catch(() => {
      //
    })
  return new Promise(resolve => {
    // @ts-ignore
    document.querySelector('.el-message-box__btns').style.display = 'none'
    if (!msg) {
      // @ts-ignore
      document.querySelector('.el-message-box__content').style.display = 'none'
    }
    const timer = setTimeout(() => {
      const closeBtn: any = document.querySelector('.el-message-box__headerbtn')
      if (closeBtn) {
        closeBtn.click()
      }
      clearTimeout(timer)
      resolve(timer)
    }, delay)
  })
}

// 匹配有data-jufair属性的标签: <([a-z][a-z0-9]*)(?=.*?data-jufair="([^"]*)")
// 匹配有data-jufair属性的标签(包含到结束标签): <([a-z][a-z0-9]*)(?=.*?data-jufair="([^"]*)").+<\/\1>

// 删除空标签  如: <div></div>
export function removeEmptyTags(str: string) {
  // 定义正则表达式匹配空标签和只包含<br>元素的标签
  const emptyTagRegex = /<(?!img\b)([\w-]+)[^>]*>(\s*|<br\s*\/?\s*>|\n|\r|&nbsp;)*<\/\1>/g

  // 如果字符串中仍然存在空标签或只包含<br>元素的标签
  while (emptyTagRegex.test(str)) {
    // 用正则表达式替换为空字符串
    str = str.replace(emptyTagRegex, '')
    // 递归删除子元素中的空标签
    str = removeEmptyTags(str)
  }

  return str
}

// 替换富文本标签
const strReplace = (data: string) => {
  try {
    const html = data
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/<(?!img\b)(\w+)\s+[^>]*>/gi, '<$1>')
      .replace(/<a>/gi, '')
      .replace(/<\/a>/gi, '')
      .replace(/<mp.*?<\/mp.*?>/gi, '')
      .replace(/<svg.*?<\/svg.*?>/gi, '')
      .replace(/<iframe.*?<\/iframe.*?>/gi, '')
      .replace(/<xml>[^]*?<\/xml>/gi, '')
      .replace(/<style>[^]*?<\/style>/gi, '')
      .replace(/<spanyes.*?<\/spanyes.*?>/gi, '')
      .replace(/<spanyes.*?"="">/gi, '')
      .replace(/<\/spanyes.*?>/gi, '')
      .replace(/<o:p>.*?<\/o:p>/gi, '')
      .replace(/<h1>/gi, '</p>')
      .replace(/<\/h1>/gi, '</p>')
      .replace(/<h2>/gi, '<p>')
      .replace(/<\/h2>/gi, '</p>')
      .replace(/<h3>/gi, '<strong>')
      .replace(/<\/h3>/gi, '</strong>')
      .replace(/<h4>/gi, '<strong>')
      .replace(/<\/h4>/gi, '</strong>')
      .replace(/<b>/gi, '<strong>')
      .replace(/<\/b>/gi, '</strong>')
      .replace(/&lt;xml&gt;[^]*?&lt;\/xml&gt;/gi, '')
      .replace(/&lt;style&gt;[^]*?&lt;\/style&gt;/gi, '')
      .replace(/&lt;o:p&gt;.*?&lt;\/o:p&gt;/gi, '')
      .replace(/&lt;spanyes.*?&lt;\/spanyes.*?&gt;/gi, '')
      .replace(/&lt;spanyes.*?"=""&gt;/gi, '')
      .replace(/&lt;\/spanyes.*?&gt;/gi, '')
      .replace(/(1[3-9]\d{9})|(\d{3,4}-\d{7,8}(-\d{1,6})?)/gi, '')
      .replace(/<img[^>]*src="data:image\/svg\+xml[^"]*"[^>]*>/gi, '')
      .replace(
        /(?:https?:\/\/)?(?:\w+\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)/gi,
        (match, p1) => {
          if (!/\d+\..?/.test(match) && !match.includes('jufair') && !match.includes('jufiar')) {
            return ''
          }
          return match
        }
      )
      .replace(/<\w+>[<br/?>]?<\/\w+>/gi, '')
      .replace(/<img([^>]*)\b_src="[^"]*"/gi, '<img$1')
      // .replace(/<img([^>]*)src=/gi, '<img$1data-src=')
      .replace(bucketHost, bucketCdnHost)

    return html
  } catch (e) {
    return data
  }
}

/**
 * 替换富文本标签
 * data 富文本内容
 * aliasRandom 随机别名
 * */
export const strReplaceImage = (data: string, aliasRandom: string) => {
  let counter = 1
  try {
    // /(<img.*?src=")(.*?)(".*?>)/gi
    // return data
    const html = data.replace(/(<img)(.*?src=")(.*?)(".*?>)/gi, function (a, b, c, d, e) {
      // console.log('225--1', b)
      // console.log('225--2', c)
      // console.log('225--3', d)
      // console.log('225--4', e)
      //a是整体
      // b 是第1个分组  <img
      //c是第2个分组  src="
      //d是第3个分组  图片url
      //e是第4个分组  ">
      // 增加图片压缩后缀 !swebp
      // if (c.includes('jufair.com') && !c.includes('!swebp')) {
      //   return `${b}${c}!swebp${d}`
      // }
      return `${b} alt="${aliasRandom}展会介绍${counter++}" ${c}${d}${e}`
      // return a
    })

    return html
  } catch (e) {
    return data
  }
}

/**
 * 替换富文本图片alt属性
 * data 富文本内容
 * name 展会名称
 * str
 * */
export const strReplaceImageAlt = (data: string, name: string, str: string) => {
  let counter = 1
  try {
    // /(<img.*?src=")(.*?)(".*?>)/gi
    // return data
    const html = data.replace(/(<img)(.*?src=")(.*?)(".*?>)/gi, function (a, b, c, d, e) {
      // console.log('225--1', b)
      // console.log('225--2', c)
      // console.log('225--3', d)
      // console.log('225--4', e)
      //a是整体
      // b 是第1个分组  <img
      //c是第2个分组  src="
      //d是第3个分组  图片url
      //e是第4个分组  ">
      // 增加图片压缩后缀 !swebp
      // if (c.includes('jufair.com') && !c.includes('!swebp')) {
      //   return `${b}${c}!swebp${d}`
      // }
      return `${b} alt="${name}${str}${counter++}" ${c}${d}${e}`
      // return a
    })

    return html
  } catch (e) {
    return data
  }
}

/**
 * 展馆分布图-替换富文本图片
 * data 富文本内容
 * aliasRandom 别名
 * */
export const cooperativePartnerReplaceImage = (data: string, aliasPrimary: string) => {
  let counter = 1
  try {
    // /(<img.*?src=")(.*?)(".*?>)/gi
    // return data
    const html = data.replace(/(<img)(.*?src=")(.*?)(".*?>)/gi, function (a, b, c, d, e) {
      // console.log('225--1', b)
      // console.log('225--2', c)
      // console.log('225--3', d)
      // console.log('225--4', e)
      //a是整体
      // b 是第1个分组  <img
      //c是第2个分组  src="
      //d是第3个分组  图片url
      //e是第4个分组  ">
      // 增加图片压缩后缀 !swebp
      // if (c.includes('jufair.com') && !c.includes('!swebp')) {
      //   return `${b}${c}!swebp${d}`
      // }
      return `${b} alt="${aliasPrimary}展馆平面图" ${c}${d}${e}`
      // return a
    })

    return html
  } catch (e) {
    return data
  }
}

export const getContent = (data: string) => {
  if (!data) return data
  try {
    return decodeURIComponent(strReplace(data))
  } catch (error) {
    if (process.client && 'fundebug' in window) {
      let str = error + 'getContent__参数:'
      // window.fundebug.notifyError(str); // decodeURIComponent方法%无法解码
    }
    // console.error(id, error);
    return strReplace(data)
  }
}

// form 表单邮箱验证
export const checkEmail = (_rule: any, value: string, callback: (msg?: string) => void) => {
  const mailReg = /^\S+@\S+\.+[a-z]{2,}$/
  if (!mailReg.test(value)) {
    callback('请输入正确的邮箱.')
  } else {
    callback()
  }
}

/*
 * JSON数组去重
 * @param: [array] json Array
 * @param: [string] 唯一的key名，根据此键名进行去重
 */
export function uniqueArray(array: any[], key: string): any[] {
  const result = [array[0]]
  for (let i = 1; i < array.length; i++) {
    const item = array[i]
    let repeat = false
    for (let j = 0; j < result.length; j++) {
      if (item[key] == result[j][key]) {
        repeat = true
        break
      }
    }
    if (!repeat) {
      result.push(item)
    }
  }
  return result
}

export function formatCover(value: string) {
  let parse: any = value
  if (typeof value === 'string') {
    try {
      //
      parse = JSON.parse(value)[0]
        .replace('http://', 'https://')
        .replace(bucketHost, bucketCdnHost)
        .replace(jufairOss, dcdnurl)
    } catch (error) {
      parse = value.replace('http://', 'https://')
      // console.error(error);
    }
  }
  return parse
}

/**
 * 自定义函数名：PrefixZero
 * @param num： 被操作数
 * @param n： 固定的总位数
 */
export function prefixZero(num: number, n: number) {
  if (`${num}`.length > n) n = `${num}`.length
  // @ts-ignore
  return (Array(n).join(0) + num).slice(-n)
}

/**
 * 秒数转为"时分秒"
 * 如: 7200秒 结果:[02, 00, 00]
 * @param {any} time:number
 * @returns {any}
 */
export function getTime(time: number) {
  // 转换为式分秒
  let h: any = parseInt(((time / 60 / 60) % 24) as any)
  h = h < 10 ? '0' + h : h
  let m: any = parseInt(((time / 60) % 60) as any)
  m = m < 10 ? '0' + m : m
  let s: any = parseInt((time % 60) as any)
  s = s < 10 ? '0' + s : s
  // 作为返回值返回
  return [String(h), String(m), String(s)]
}

// 获取今天的日期
export const getTodayDate = () => {
  const today = new Date()
  let year = today.getFullYear() // 获取当前年份
  let month = today.getMonth() + 1 // 获取当前月份（注意月份是从0开始计数的）
  let day = today.getDate() // 获取当前日期

  return `${year}-${month}-${day}`
}

// 获取周一的日期
export const getWeekDate = () => {
  // 获取当前日期
  const currentDate = new Date()

  // 获取当前日期是周几
  const currentDay = currentDate.getDay()

  // 计算周一的日期
  const mondayDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate() - ((currentDay + 6) % 7) // + 1
  )

  let today = new Date(mondayDate)
  let year = today.getFullYear() // 获取当前年份
  let month = today.getMonth() + 1 // 获取当前月份（注意月份是从0开始计数的）
  let day = today.getDate() // 获取当前日期

  return `${year}-${month}-${day}`
}

// 获取当月第一天的日期
export const getMonthDate = () => {
  const today = new Date()
  let year = today.getFullYear() // 获取当前年份
  let month = today.getMonth() + 1 // 获取当前月份（注意月份是从0开始计数的）
  let day = today.getDate() // 获取当前日期

  return `${year}-${month}-01`
}

// 时间戳转年月日时分秒
export function timestampToDateTime(timestamp: any) {
  const date = new Date(timestamp)
  const year = date.getFullYear()
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const day = ('0' + date.getDate()).slice(-2)
  const hours = ('0' + date.getHours()).slice(-2)
  const minutes = ('0' + date.getMinutes()).slice(-2)
  const seconds = ('0' + date.getSeconds()).slice(-2)

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

export function getXOssProcess({ w = 100, h = 100, watermark }: Record<string, any>) {
  return `?x-oss-process=image/auto-orient,1/interlace,1/resize,m_fill,w_${w},h_${h}/quality,q_100${
    watermark ? '/watermark,image_bG9nby9qdXpoYW4ucG5nP3gtb3NzLXByb2Nlc3M9aW1hZ2UvcmVzaXplLFBfMTI,x_10,y_10' : ''
  }`
}

/**
 * oss图片转webp格式+图片尺寸压缩
 * w 图片宽度
 * h 图片高度
 * watermark 是否添加水印
 */
export function getXOssWebpSize({ w, h, watermark }: Record<string, any>) {
  return `?x-oss-process=image/resize,w_${w},h_${h}/format,webp${
    watermark ? '/watermark,image_bG9nby9qdXpoYW4ucG5nP3gtb3NzLXByb2Nlc3M9aW1hZ2UvcmVzaXplLFBfMTI,x_10,y_10' : ''
  }`
}

/**
 * oss图片转webp格式+图片尺寸压缩
 * url 图片地址
 * w 图片宽度
 * h 图片高度
 * watermark 是否添加水印 true是, false否
 * 使用示例: handleOssWebpSize({url: 'https://dcdn-jufair.jufair.com/service/li.jpg', w: 800, h: 560, watermark: false })
 */
export function handleOssWebpSize({ url, w, h, watermark }: Record<string, any>) {
  if ((url ?? '') === '') {
    return ''
  }
  if (url.includes('undefined')) {
    url = ''
  }
  // url = formatCover(url); // http替换为https
  if (!checkWebpSupport) return
  url = url.replace('http://', 'https://').replace(bucketHost, bucketCdnHost) // 替换cdn域名
  const isCDN = /(aliyuncs.com)|(file.jufair.com)|(.jufair.com)/
  //
  if (isCDN.test(url) && !url.includes('?x-oss-process=') && !url.includes('!webp') && !url.includes('!swebp')) {
    return `${url}?x-oss-process=image/resize,w_${w},h_${h}/format,webp/quality,q_100${
      watermark ? '/watermark,image_bG9nby9qdXpoYW4ucG5nP3gtb3NzLXByb2Nlc3M9aW1hZ2UvcmVzaXplLFBfMTI,x_10,y_10' : ''
    }`
  }
  return url
}

export const decryptAndReplace = (content: string, secret: string) => {
  if (!secret) return content
  // Base64 解密
  const decodedString = Buffer.from(secret, 'base64').toString()

  // 用下划线切割
  const parts = decodedString.split('_')
  // 十六进制转十进制
  const decimalIndexes = parts
    .slice(1)
    .map(hex => parseInt(hex, 16))
    .sort((a: number, b: number) => a - b)

  // 替换原文中对应下标的字符为空白字符
  let originalText = content // 请替换成实际的原文
  decimalIndexes.forEach((index, i) => {
    if (index >= 0 && index < content.length) {
      originalText = originalText.substring(0, index - i) + '' + originalText.substring(index - i + 1)
    }
  })

  return originalText
}

/**
 * 处理资讯url(检查资讯的viewUrl属性)
 * 如果viewUrl是null，则跳转/information/页面
 * 否则跳转viewUrl的值对应的页面
 *
 * 同时资讯详情页asyncData中检查viewUrl,
 * 如果viewUrl是null，则跳转/information/页面
 * 否则跳转viewUrl的值对应的页面
 *
 * str 资讯url
 * id 资讯id
 *
 * */
export const handleNewsUrl = (str: string, id: string | number) => {
  let url = ''
  // if (str) {
  //   url = `${str}`
  // } else {
  //   url = `/information/${id}.html`
  // }
  url = `/information/${id}.html`
  return url
}

// 计算页面白屏时间（旧的） TTFB: 服务器响应时间（对 SSR 应用很重要）
export const getWhiteScreenTimeOriginal = () => {
  if (!process.client) return
  if (window.performance) {
    // 获取performance的timing信息
    const performance = window.performance
    // 获取unloadEventStart和fetchStart的时间戳
    const unloadTime = performance.timing.unloadEventStart - performance.timing.fetchStart
    const redirectTime = performance.timing.redirectEnd - performance.timing.redirectStart
    const appCacheTime = performance.timing.domainLookupStart - performance.timing.fetchStart
    const dnsTime = performance.timing.domainLookupEnd - performance.timing.domainLookupStart // dns解析耗时
    const tcpTime = performance.timing.connectEnd - performance.timing.connectStart // tcp连接耗时
    const firstPaintTime = performance.timing.responseStart - performance.timing.fetchStart

    // 计算白屏时间
    const whiteScreenTime = unloadTime + redirectTime + appCacheTime + dnsTime + tcpTime + firstPaintTime

    // console.log(`白屏时间（ms）: ${whiteScreenTime.toFixed(0)}`);
    let res1 = performance.timing.domLoading - performance.timing.fetchStart
    let res2 = performance.timing.responseStart - performance.timing.fetchStart // performance.timing.responseEnd - performance.timing.fetchStart;
    let res3 = performance.timing.responseEnd - performance.timing.fetchStart
    // console.log(res1);
    console.log(`白屏时间（ms）: ${res2}`)
    // 页面白屏时间大于10秒时，打印日志(2025-07-16)
    if (String(res2).length < 13 && res2 > 10000) {
      // const fundebug = require('fundebug-javascript');
      // notify参数：名称, 信息
      window.fundebug.notify('页面白屏时间', `白屏时间: ${res2}; 所有资源加载完成:${res3}`, {
        metaData: {
          pageUrl: window.location.href,
          whiteScreenTime: res2, // whiteScreenTime.toFixed(0),
          all_resources_loading: res3
        }
      }) // ${whiteScreenTime.toFixed(0)}
    }
  }
}

/**
 * 获取页面性能指标（适用于 Nuxt 4 SSR 应用）
 * 使用现代 Performance API 获取真实的性能数据
 * FCP: 首次内容绘制（真正的白屏时间）
 */
export const getWhiteScreenTime = () => {
  if (!process.client) return

  // 使用 requestIdleCallback 或 setTimeout 确保性能数据已收集完成
  const measurePerformance = () => {
    try {
      const perfData = {
        // Navigation Timing Level 2 (现代 API)
        navigationEntry: performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming,
        // Paint Timing API (真正的白屏时间)
        paintEntries: performance.getEntriesByType('paint') as PerformancePaintTiming[],
        // 页面 URL
        pageUrl: window.location.href
      }

      if (!perfData.navigationEntry) {
        console.warn('Navigation Timing API 不可用')
        return
      }

      const nav = perfData.navigationEntry

      // ========== 关键性能指标 ==========

      // 1. TTFB (Time To First Byte) - 服务器响应时间
      const ttfb = Math.round(nav.responseStart - nav.requestStart)

      // 2. FCP (First Contentful Paint) - 首次内容绘制（真正的白屏时间）
      const fcpEntry = perfData.paintEntries.find(entry => entry.name === 'first-contentful-paint')
      const fcp = fcpEntry ? Math.round(fcpEntry.startTime) : null

      // 3. FP (First Paint) - 首次绘制
      const fpEntry = perfData.paintEntries.find(entry => entry.name === 'first-paint')
      const fp = fpEntry ? Math.round(fpEntry.startTime) : null

      // 4. DOM Ready - DOM 解析完成时间
      const domReady = Math.round(nav.domContentLoadedEventEnd - nav.fetchStart)

      // 5. Load Complete - 页面完全加载时间
      const loadComplete = Math.round(nav.loadEventEnd - nav.fetchStart)

      // 6. DNS 查询时间
      const dnsTime = Math.round(nav.domainLookupEnd - nav.domainLookupStart)

      // 7. TCP 连接时间
      const tcpTime = Math.round(nav.connectEnd - nav.connectStart)

      // 8. SSL 握手时间
      const sslTime = nav.secureConnectionStart > 0 ? Math.round(nav.connectEnd - nav.secureConnectionStart) : 0

      // 9. 请求响应时间
      const requestTime = Math.round(nav.responseEnd - nav.requestStart)

      // 10. DOM 解析时间
      const domParseTime = Math.round(nav.domInteractive - nav.responseEnd)

      // 构建性能报告
      const performanceReport = {
        // 核心指标
        ttfb, // 服务器响应时间
        fcp, // 首次内容绘制（白屏时间）
        fp, // 首次绘制
        domReady, // DOM Ready
        loadComplete, // 完全加载

        // 网络时间分解
        dnsTime, // DNS 查询
        tcpTime, // TCP 连接
        sslTime, // SSL 握手
        requestTime, // 请求响应
        domParseTime, // DOM 解析

        // 页面信息
        pageUrl: perfData.pageUrl,
        timestamp: Date.now()
      }

      // 输出到控制台
      console.group('📊 页面性能指标 (Nuxt 4 SSR)')
      console.log(`⏱️  TTFB (服务器响应): ${ttfb}ms`)
      console.log(`🎨 FCP (首次内容绘制/白屏时间): ${fcp || 'N/A'}ms`)
      console.log(`🎨 FP (首次绘制): ${fp || 'N/A'}ms`)
      console.log(`📄 DOM Ready: ${domReady}ms`)
      console.log(`✅ Load Complete: ${loadComplete}ms`)
      console.log('---')
      console.log(`🌐 DNS: ${dnsTime}ms | TCP: ${tcpTime}ms | SSL: ${sslTime}ms`)
      console.log(`📡 Request: ${requestTime}ms | DOM Parse: ${domParseTime}ms`)
      console.groupEnd()

      // ========== 性能告警 ==========
      // 白屏时间（FCP）大于 2.5 秒（Web Vitals 阈值）时报警
      const fcpThreshold = 10000 //2500
      if (fcp && fcp > fcpThreshold) {
        console.warn(`⚠️ FCP (${fcp}ms) 超过推荐值 (${fcpThreshold}ms)`)

        // 如果白屏时间大于 10 秒，上报到错误监控
        if (fcp > 10000 && window.fundebug) {
          window.fundebug.notify('页面白屏时间异常 (FCP)', `白屏时间: ${fcp}ms 超过阈值`, {
            metaData: performanceReport
          })
        }
      }

      // TTFB 大于 1.8 秒时报警（Web Vitals 阈值）
      const ttfbThreshold = 10000 // 1800
      if (ttfb > ttfbThreshold) {
        console.warn(`⚠️ TTFB (${ttfb}ms) 超过推荐值 (${ttfbThreshold}ms)`)

        // 如果 TTFB 大于 5 秒，上报到错误监控
        if (ttfb > 10000 && window.fundebug) {
          window.fundebug.notify('服务器响应时间异常 (TTFB)', `TTFB: ${ttfb}ms 超过阈值`, {
            metaData: performanceReport
          })
        }
      }

      return performanceReport
    } catch (error) {
      console.error('获取性能指标失败:', error)
    }
  }

  // 等待所有资源加载完成后再测量
  if (document.readyState === 'complete') {
    measurePerformance()
  } else {
    window.addEventListener('load', () => {
      // 延迟一点确保 Paint Timing 数据已记录
      setTimeout(measurePerformance, 0)
    })
  }
}

/**
 * 接口错误处理
 * list 错误列表
 * url 来源页面
 * */
export const handleApiError = (list: any, url: string = '/') => {
  if (list.length > 0) {
    console.log('385-接口请求失败')
    window.location.replace(`${window.location.origin}/system/error?redirect=${url}`)
  }
}

/**
 * 处理node服务错误
 * 使用场景 组件asyncData中
 * e ctx上下文
 * message 具体错误信息(包括接口状态码, 接口url)
 *
 * */
export const handleNodeServerError = (message: string) => {
  console.error(
    'MODE=' + MODE + ' baseUrl=' + env[MODE].BASE_URL + '服务器错误-util/common.ts-handleNodeServerError',
    message,
    '时间:',
    timestampToDateTime(Date.now())
  )
  console.trace('服务器错误-util/common.ts-handleNodeServerError', message) // 可在node服务控制台查看（具体报错接口url和状态码）
  //     logger?.error(message);
  //   });
  // console.log(message)

  // 使用statusMessage会报错：
  // please prefer using 'mesage’ for longer error messages instead of 'statusMessage’. In the future, 'statusessage will be sanitized by default.
  throw createError({
    statusCode: 504,
    statusMessage: '', // '服务器错误-请稍后重试',
    message: JSON.stringify({
      errorMsg: message,
      message: message,
      time: timestampToDateTime(Date.now())
    })
  } as any)
  return navigateTo('/error', { message: message })
}

let _checkWebpSupport: boolean | Promise<boolean> = (() => {
  return new Promise(resolve => {
    if (process.server) {
      resolve(true)
      _checkWebpSupport = true
    } else {
      const img = new Image()
      img.onload = () => {
        resolve(true)
        _checkWebpSupport = true
      }
      img.onerror = () => {
        resolve(false)
        _checkWebpSupport = false
      }
      img.src = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA='
    }
  })
})()

export const checkWebpSupport = _checkWebpSupport
// 判断是否是CDN资源，是否需要加后缀
export const isAddSuffix = (originalSrc: any) => {
  const isCDN = /(aliyuncs.com)|(file.jufair.com)|(.jufair.com)|(dcdn-jufair.jufair.com)/
  // 判断URL是否已包含OSS处理后缀的正则
  const hasOssProcessingSuffix = /\.(jpg|jpeg|png|gif|webp|bmp|svg)!(webp|swebp|logo|[a-zA-Z0-9_-]+)/i
  return (
    isCDN.test(originalSrc) && !originalSrc.includes('?x-oss-process=') && !hasOssProcessingSuffix.test(originalSrc)
  )
}
export const getWebp = (originalSrc: string, isSwebp: any) => {
  if (!originalSrc || originalSrc.includes('undefined')) {
    originalSrc = ''
  }
  originalSrc = formatCover(originalSrc)
  originalSrc = originalSrc
    .replace('http://', 'https://')
    .replace(bucketHost, bucketCdnHost)
    .replace(jufairOss, dcdnurl)
  if (!checkWebpSupport) return
  if (isAddSuffix(originalSrc)) {
    originalSrc = originalSrc?.split('?')[0]
    if (!originalSrc.includes('!webp') && !originalSrc.includes('.webp') && !isSwebp) {
      originalSrc += '!webp'
    }
    if (!originalSrc.includes('!swebp') && !originalSrc.includes('.swebp') && isSwebp) {
      originalSrc += '!swebp'
    }
    return originalSrc
  } else {
    return originalSrc
  }
}

export const removeNullValues = (obj: any, fields: string[] = []): any => {
  if (Array.isArray(obj)) {
    return obj.map(k => removeNullValues(k, fields)).filter(item => item !== null)
  } else if (obj !== null && _.isObject(obj)) {
    return Object.keys(obj).reduce((acc, key) => {
      // @ts-ignore
      const value = removeNullValues(obj[key], fields)
      if (fields.length > 0) {
        fields = fields.concat(['code', 'data', 'message', 'errorMessage', 'records'])
        if (value !== null && !['pageNum', 'pageSize'].includes(key) && fields.includes(key)) {
          acc[key] = value
        }
      } else {
        if (value !== null && !['pageNum', 'pageSize'].includes(key)) {
          acc[key] = value
        }
      }
      return acc
    }, {} as any)
  }
  return obj
}

/**
 * 为给定的输入字符串生成 SHA-256 哈希值。
 *
 * @param {string} input - 要哈希的输入字符串。
 * @returns {string} - 十六进制格式的结果 SHA-256 哈希值。
 */
export const generateHash = (input: string): string => {
  const hash = crypto.SHA256(input)
  return hash.toString(crypto.enc.Hex)
}

/**
 * 生成大写英文字母（A-Z）的数组
 */
export const alphabet = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i))

// 检查展会列表页url是否合法
export const handleCheckUrl = (url: string, mark: any) => {
  if (String(url).includes('NaN')) {
    console.log('参数有误-1001', mark, url)
  }
  return url
}
import headimg from '~/assets/images/placeholder-error.webp'
export const handleAvatarError = (event: string | Event) => {
  if (process.client) {
    // 如果是字符串，直接返回，不处理
    if (typeof event === 'string') return
    const target = event.target as HTMLImageElement
    if (target) {
      target.src = headimg
      target.srcset = headimg
      // 防止无限循环
      target.onerror = null
    }
  }
}

/**
 * 自动导入指定目录下的所有模块
 * @param modules import.meta.glob 的结果
 * @param excludeFiles 要排除的文件名数组
 * @returns 合并后的模块对象
 */
export function autoImportModules(
  modules: Record<string, any>,
  excludeFiles: string[] = ['index']
): Record<string, any> {
  const result: Record<string, any> = {}

  Object.entries(modules).forEach(([path, module]) => {
    const moduleName = path.replace('./', '').replace('.ts', '')

    if (!excludeFiles.includes(moduleName)) {
      // 兼容 @nuxtjs/i18n 10.0.3+ 版本的模块加载方式
      // 在新版本中，模块可能是一个函数或者已经是默认导出
      if (typeof module === 'function') {
        // 如果是函数，调用它获取模块
        const resolvedModule = module()
        result[moduleName] = resolvedModule?.default || resolvedModule
      } else {
        // 否则直接使用默认导出或模块本身
        result[moduleName] = module?.default || module
      }
    }
  })

  return result
}

/**
 * 分块并发处理器
 * @param requests 异步请求数组
 * @param options 配置选项
 */
export const batchProcessRequests = async <T>(
  requests: (() => Promise<T>)[],
  options?: { parallel?: boolean }
): Promise<T[]> => {
  let results: T[] = []
  // 根据设备性能自动调整块大小
  const chunkSize = navigator?.hardwareConcurrency || 5

  // 分块处理逻辑
  for (let i = 0; i < requests.length; i += chunkSize) {
    const chunk = requests.slice(i, i + chunkSize).map(fn => fn().catch(e => e)) // 错误捕获

    // 执行策略选择
    const chunkResults = options?.parallel
      ? await Promise.all(chunk) // 并行执行块
      : await executeSequentially(chunk) // 串行执行块

    results = results.concat(chunkResults)
  }
  return results
}

// 串行执行辅助函数
const executeSequentially = async <T>(tasks: Promise<T>[]): Promise<T[]> => {
  const results: T[] = []
  for (const task of tasks) {
    results.push(await task)
  }
  return results
}

/**
 * 下载带边距和头部的 Canvas 为 PDF
 */
async function downloadCanvasWithMargin(canvas: any, resolve: (value: string) => void, jsPDF: any, moment: any) {
  const canvasArr = []
  let searchParams

  if (process.client) {
    searchParams = new URLSearchParams(location.search)
  }

  // 关闭锯齿
  const context = canvas.getContext('2d')
  context.mozImageSmoothingEnabled = false
  context.webkitImageSmoothingEnabled = false
  context.msImageSmoothingEnabled = false
  context.imageSmoothingEnabled = false

  const contentWidth = canvas.width
  const contentHeight = canvas.height

  // 一页pdf显示html页面生成的canvas高度;
  const pageHeight = (contentWidth / 595.28) * 841.89
  // 未生成pdf的html页面高度
  let leftHeight = contentHeight
  let cutStartHeight = 0

  // 当内容未超过pdf一页显示的范围，无需分页
  if (leftHeight > pageHeight) {
    while (leftHeight > 0) {
      const cutImage = context.getImageData(0, cutStartHeight, contentWidth, pageHeight)

      // 创建新图片
      const newCanvas = document.createElement('canvas') // 创建一个canvas节点
      newCanvas.width = canvas.width
      newCanvas.height = pageHeight
      const nContext: any = newCanvas.getContext('2d')
      nContext.mozImageSmoothingEnabled = false
      nContext.webkitImageSmoothingEnabled = false
      nContext.msImageSmoothingEnabled = false
      nContext.imageSmoothingEnabled = false
      nContext.putImageData(cutImage, 0, 0)
      canvasArr.push(newCanvas)

      leftHeight -= pageHeight
      cutStartHeight += pageHeight
    }
  } else {
    canvasArr.push(canvas)
  }

  // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
  const imgWidth = 510
  const imgHeight = (510 / contentWidth) * contentHeight

  const pdf = new jsPDF('p', 'pt', 'a4', true)

  // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
  for (let i = 0; i < canvasArr.length; i++) {
    const curCanvas = canvasArr[i]
    const img = new Image()

    // 根据类型选择不同的头部图片
    if (searchParams?.get('type') === 'tianxi') {
      // 使用静态资源路径
      img.src = '/assets/images/tianxi-header.webp'
    } else {
      // 使用静态资源路径
      img.src = '/assets/images/pdf-header.webp'
    }

    pdf.addImage(img, 'JPEG', 40, 30, imgWidth, 38)

    const pageData = curCanvas.toDataURL('image/png', 1.0)
    // 小于切分的高度，要换算比例高
    if (curCanvas.height < pageHeight) {
      const ratioHeight = (imgWidth / curCanvas.width) * curCanvas.height
      pdf.addImage(pageData, 'JPEG', 40, 70, imgWidth, ratioHeight)
    } else {
      pdf.addImage(pageData, 'JPEG', 40, 70, imgWidth, imgHeight)
    }
    pdf.setDrawColor(255, 0, 0)
    pdf.setLineWidth(1)
    pdf.line(40, 810, imgWidth + 40, 810)
    if (i < canvasArr.length - 1) {
      pdf.addPage()
    }
  }

  const fileName = moment().format('YYYY-MM-DD_SSS')
  await pdf.save(`${fileName}.pdf`)
  resolve(`${fileName}.pdf`)
}

/**
 * 导出带头部的 PDF
 * @param containerId 要导出的容器 ID
 * @returns Promise<string> 返回生成的文件名
 */
export async function exportPDFWithHeader(containerId: string): Promise<string> {
  if (!process.client) {
    console.warn('PDF export is only available on client side')
    return Promise.resolve('')
  }

  try {
    console.log('开始加载 PDF 导出依赖...')

    // 动态导入依赖库
    const [{ default: html2canvas }, jsPDFModule, moment] = await Promise.all([
      import('html2canvas'),
      import('jspdf'),
      import('moment')
    ])

    // 兼容不同版本的 jsPDF 导入方式
    const jsPDF = jsPDFModule.jsPDF || jsPDFModule.default || jsPDFModule

    console.log('PDF 依赖加载完成，开始生成 PDF...')

    const pdfContent = document.getElementById(containerId)
    if (!pdfContent) {
      throw new Error(`Element with id "${containerId}" not found`)
    }

    const opts = {
      background: '#fff',
      taintTest: true, // 检测每张图片都已经加载完成
      useCORS: true, // 开启跨域配置
      allowTaint: true // 允许加载跨域的图片
    }

    return new Promise((resolve, reject) => {
      html2canvas(pdfContent, opts)
        .then(async (canvas: any) => {
          await downloadCanvasWithMargin(canvas, resolve, jsPDF, moment.default)
        })
        .catch(reject)
    })
  } catch (error) {
    console.error('PDF export failed:', error)
    throw error
  }
}

/**
 * 检查是否支持 PDF 导出
 */
export function isPDFExportSupported(): boolean {
  return process.client && typeof document !== 'undefined'
}

/**
 * 下载带边距的 Canvas 为 PDF
 */
async function downloadCanvasWithMargin2(canvas: any, resolve: (value: string) => void, jsPDF: any, moment: any) {
  const canvasWidth = canvas.width
  const canvasHeight = canvas.height
  const imgWidth = 210 - 80 // A4 宽度减去边距
  const imgHeight = (canvasHeight * imgWidth) / canvasWidth
  const pageHeight = 297 - 80 // A4 高度减去边距

  let leftHeight = imgHeight
  let position = 0
  const canvasArr: any[] = []

  // 分页处理
  while (leftHeight > 0) {
    const checkHeight = leftHeight > pageHeight ? pageHeight : leftHeight
    const tempCanvas = document.createElement('canvas')
    tempCanvas.width = canvasWidth
    tempCanvas.height = (checkHeight * canvasWidth) / imgWidth

    const tempCtx = tempCanvas.getContext('2d')
    if (tempCtx) {
      tempCtx.drawImage(
        canvas,
        0,
        position,
        canvasWidth,
        (checkHeight * canvasWidth) / imgWidth,
        0,
        0,
        canvasWidth,
        (checkHeight * canvasWidth) / imgWidth
      )
    }

    canvasArr.push(tempCanvas)
    leftHeight -= pageHeight
    position += (checkHeight * canvasWidth) / imgWidth
  }

  // 创建 PDF
  const pdf = new jsPDF('p', 'pt', 'a4')

  for (let i = 0; i < canvasArr.length; i++) {
    const tempCanvas = canvasArr[i]
    const tempImgData = tempCanvas.toDataURL('image/jpeg', 1.0)

    if (i === 0) {
      pdf.addImage(tempImgData, 'JPEG', 40, 40, imgWidth, (tempCanvas.height * imgWidth) / tempCanvas.width)
    } else {
      pdf.addPage()
      pdf.addImage(tempImgData, 'JPEG', 40, 40, imgWidth, (tempCanvas.height * imgWidth) / tempCanvas.width)
    }

    // 添加页脚线
    pdf.setDrawColor(255, 0, 0)
    pdf.setLineWidth(1)
    pdf.line(40, 810, imgWidth + 40, 810)
  }

  const fileName = moment().format('YYYY-MM-DD_SSS')
  await pdf.save(`${fileName}.pdf`)
  resolve(`${fileName}.pdf`)
}

/**
 * 导出 PDF 主函数
 * @param containerId 要导出的容器 ID
 * @returns Promise<string> 返回生成的文件名
 */
export async function exportPDF(containerId: string): Promise<string> {
  if (!process.client) {
    console.warn('PDF export is only available on client side')
    return Promise.resolve('')
  }

  try {
    // 动态导入依赖库
    const [{ default: html2canvas }, { jsPDF }, moment] = await Promise.all([
      import('html2canvas'),
      import('jspdf'),
      import('moment')
    ])

    const pdfContent = document.getElementById(containerId)
    if (!pdfContent) {
      throw new Error(`Element with id "${containerId}" not found`)
    }

    const opts = {
      background: '#fff',
      taintTest: true, // 检测每张图片都已经加载完成
      useCORS: true, // 开启跨域配置
      allowTaint: true // 允许加载跨域的图片
    }

    return new Promise((resolve, reject) => {
      html2canvas(pdfContent, opts)
        .then(async (canvas: any) => {
          await downloadCanvasWithMargin2(canvas, resolve, jsPDF, moment.default)
        })
        .catch(reject)
    })
  } catch (error) {
    console.error('PDF export failed:', error)
    throw error
  }
}

/**
 * 周时间(周)
 * 展会详情页的"更新时间"计算
 * id 展会id
 * id % 7(一周7天)，值作为上周周几
 *  最终返回上周的一个日期
 */
export const getExhibitionUpdateTime = (id: number) => {
  const today = new Date()
  let lastWeekValue: any = id % 7

  const todayDayOfWeek = today.getDay() // 0=周日, 1=周一, ..., 6=周六

  // 周三对应数字 3
  // 计算距离上周三的天数差
  let daysSinceLastWednesday

  if (todayDayOfWeek >= lastWeekValue) {
    // 如果今天是周三或之后，上周三就是今天减去 (todayDayOfWeek - 3 + 7) 天
    daysSinceLastWednesday = todayDayOfWeek - lastWeekValue + 7
  } else {
    // 如果今天是周一或周二，上周三就是今天减去 (todayDayOfWeek + 4) 天
    daysSinceLastWednesday = todayDayOfWeek + 4
  }

  const lastWednesday = new Date(today)
  lastWednesday.setDate(today.getDate() - daysSinceLastWednesday)

  const today2 = new Date(lastWednesday)
  let year = today2.getFullYear() // 获取当前年份
  let month = today2.getMonth() + 1 // 获取当前月份（注意月份是从0开始计数的）
  let day = today2.getDate() // 获取当前日期

  return `${year}-${month}-${day}`
}

/**
 * 月时间(月)
 * 展会详情页的"更新时间"计算
 * id 展会id
 *
 */
export const getExhibitionUpdateTimeM = (id: number) => {
  const today = new Date()
  let year = today.getFullYear() // 获取当前年份
  let month = today.getMonth() + 1 // 获取当前月份（注意月份是从0开始计数的）
  let day = today.getDate() // 获取当前日期
  let val: any = id % 28
  val = val < 10 ? `0${val}` : val
  let m: any = ''
  let result = ''
  if (val > day) {
    // val 大于今天的日期,则使用上个月月份 month
    m = month - 1
    m = m < 10 ? `0${m}` : m
    result = `${year}-${m}-${val}`
  } else {
    // val 小于等于今天的日期,则使用当前月份 month
    result = `${year}-${month}-${val}`
  }

  return result
}

/**
 * 查看地图
 * @param lat 纬度
 * @param lng 经度
 * @address 地址
 * @regionType 0国内, 1国外
 * 文档：https://lbsyun.baidu.com/faq/api?title=webapi/uri/web
 * */
export const handleViewMap = (lat: any, lng: any, address: string, regionType: number) => {
  console.log('查看地图函数--', lat, lng, address)
  if (regionType == 0) {
    // 国内
    window.open(
      `http://api.map.baidu.com/geocoder?location=${lat},${lng}&coord_type=gcj02&output=html&src=webapp.baidu.openAPIdemo`,
      '_blank'
    )
  } else {
    // 国外
    window.open(
      `http://api.map.baidu.com/geocoder?address=${address}&output=html&src=webapp.baidu.openAPIdemo`,
      '_blank'
    )
  }
}
